
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../../Helper/Context";
import { Loading } from "../../../../../../../../../Helper/Loading";
import { ItemListTableDataAPI } from "../../../../../../../../../Redux/EnchrochmentDashboardSlice/ComplaintStatusOfficialsSlice/AcknowledgedComplaintSlice";


const ItemListPopUp = (prop) => {
    const { handleSizedItemDetail, handleItemList, heading, Data, DashSelect, YearValue, MonthValue, ZoneValue,Flag } = prop

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [OwnerDtails, setOwnerDtails] = useState([])
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const { t } = useTranslation()

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            T_Encroach_CreateSchedulingID: Data.t_Encroach_CreateSchedulingID,
            T_Encroach_CreateScheduling_OwnerDetailsID: Data.t_Encroach_CreateScheduling_OwnerDetailsID,
            T_Encroach_ComplaintDetails_OwnerDetailsID : Data.t_Encroach_ComplaintDetails_OwnerDetailsID,
            T_ComplaintDetailsID : Data.t_ComplaintDetailsID,
            M_WorkTypeID: DashSelect,
            Language: Language.Label ,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: "ItemList",
            APIFlag : Flag

        }
        dispatch(ItemListTableDataAPI({ data }))
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, Language.Label, ZoneValue])

    const { isLoading, tableData } = useSelector(state => state.ItemListTableData)


    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                {heading}
                            </h5>
                            <button
                                onClick={() => handleItemList()}
                                type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {isLoading && <Loading/>}
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                    <div className="table-responsive pt-3">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="w-6 text-center px-5">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center px-5">{t('EncroachmentDashboard.ItemList')}</th>
                                                    <th className="text-center px-5">{t('EncroachmentDashboard.Count')}</th>

                                                </tr>

                                            </thead>
                                            <tbody>
                                                {
                                                    tableData && tableData?.length > 0 ? tableData?.map((i, j) => {
                                                        return (
                                                            <tr>
                                                                <td className="py-1" align="center">{i.rowNum}</td>
                                                                <td className="nowrap" >{i.itemName ? i.itemName : '-'}</td>
                                                                <td className="nowrap" >{i.itemCount ? i.itemCount : '-'}</td>

                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <tr>
                                                            <td colSpan={10}>No data found ...</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* {tableData && tableData.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={tableData && tableData[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                            IsClear={IsClear}
                                        />
                                    } */}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default ItemListPopUp;